module.exports = __webpack_public_path__ + "static/img/grab.7e322135.png";